<template>
  <div class="success" v-if="code == 0">
    <div class="row" v-if="novoCartao && usuario === null && validado === 0">
      <div class="col-xs-12">
        <div class="success-box">
          <h1 class="bold">Estamos quase lá!</h1>

          <h3>Agora precisamos confirmar seu cartão de crédito.</h3>

          <div class="padding-l25">
            <p class="sub-title">
              <span class="badge">1</span> Consulte o valor exato debitado.
            </p>
            <p class="sub-info">
              Realizamos um débito em sua fatura de baixo valor (inferior a R$
              2,00), que será estornado posteriormente. Esse valor pode ser
              verificado em sua fatura ou no aplicativo do seu cartão de
              crédito.
            </p>
          </div>

          <div class="padding-l25">
            <p class="sub-title">
              <span class="badge">2</span> Informando o valor debitado.
            </p>
            <p class="sub-info">
              Caso já tenha em mãos o valor simbólico debitado em seu cartão de
              crédito, informe no campo abaixo e confirme. Importante lembrar
              que o pedido tem 48 horas para ser confirmado, caso contrário,
              será
              <span>cancelado</span>.
            </p>

            <div class="form-group">
              <label for="">Valor debitado (R$):</label>
              <input
                v-model.lazy="valorDebitado"
                class="form-control"
                type="text"
                name=""
                value=""
                v-mask-one-real
              />
            </div>
            <div
              v-if="msgErro"
              class="alert alert-danger alert-margin"
              role="alert"
            >
              {{ msgErro }}
            </div>
            <div class="">
              <button
                type="button"
                class="btn btn-success"
                @click="confirmCard()"
              >
                Confirmar valor
                <i class="icon-tick align-icon-right-white"></i>
              </button>
              <router-link
                :to="{ name: 'plans' }"
                tag="button"
                class="btn btn-danger"
              >
                <i class="icon-circle-cancel align-icon-left"></i>
                Agora não!
              </router-link>
            </div>
          </div>

          <div class="padding-l25 margin-t30">
            <p class="sub-title">
              <span class="badge">3</span> Ainda não tenho o valor simbólico
              debitado no cartão.
            </p>
            <p class="sub-info">
              Caso não tenha em mãos o valor simbólico debitado em seu cartão de
              crédito, você poderá informar o valor posteriormente. Importante
              lembrar que o pedido tem 48 horas para ser confirmado, caso
              contrário, será cancelado.
            </p>
          </div>

          <div class="">
            <p class="alert alert-info" role="alert">
              Para sua segurança, certifique-se de que as informações e valores
              estão corretos. Após a efetivação de sua compra, você receberá um
              e-mail com todas as informações para a ativação do seu contrato.
              Em caso de dúvidas, entre em contato com nossa
              <b>Central de Relacionamento</b>.
            </p>
          </div>
        </div>

        <div
          class="modal fade bs-example-modal-sm modal-success-adhesion"
          id="modalSuccessAdhesion"
          tabindex="-1"
          role="dialog"
          aria-labelledby="successAdhesionLabel"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="successAdhesionLabel">
                  Compra realizada com sucesso!
                </h4>
              </div>
              <div class="modal-body">
                <h4>Seja bem vindo(a) a Move Mais!</h4>
                <img
                  class="margin-10"
                  src="/static/Icon-check-circle.svg"
                  alt="icon-check-circle"
                />
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-primary"
                  type="button"
                  data-dismiss="modal"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="welcome-box" v-else-if="newPix">

      <h2 v-if="!isMobile" class="bold welcome" style="color: #5d3b81">
        Pagamento por Pix!
      </h2>
      <h2 v-else class="bold welcome" style="color: #5d3b81; font-size: 30px">
        Pagamento por Pix!
      </h2>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 50px;
        "
      >
        <qrcode-vue
          v-if="pixCopiaCola"
          :value="pixCopiaCola"
          :size="250"
          level="H"
        />
        <label
          style="
            user-select: none;
            width: 250px;
            padding: 8px;
            background-color: #f5f5f5;
            overflow: hidden;
            white-space: nowrap;
          "
        >
          {{ pixCopiaCola }}
        </label>
        <button
          id="qrcode"
          v-if="pixCopiaCola"
          @click="copyQRCodePix(pixCopiaCola)"
          :class="{ 'btn-qr-copied': isQRCopied }"
          style="font-size: 12px"
          class="btn btn-purple margin-5"
          type="button"
        >
          {{ isQRCopied ? "Copiado" : "Copiar" }}
        </button>
      </div>
      <p class="margin-t30">
        Após a conclusão do pagamento, você será notificado.
      </p>
      <div class="text-center">
        <router-link
          v-if="!isMobile"
          tag="button"
          :to="{ name: 'plans' }"
          class="btn btn-purple margin-20"
          type="button"
          name="button"
        >
          Acessar minha conta
          <i class="icon-circle-right align-icon-right-white"></i>
        </router-link>
        <router-link
          v-else
          tag="button"
          :to="{ name: 'plans' }"
          style="font-size: 12px"
          class="btn btn-purple margin-20"
          type="button"
          name="button"
        >
          Acessar minha conta
          <i class="icon-circle-right align-icon-right-white"></i>
        </router-link>
      </div>
      <p class="margin-t30">
        Em caso de dúvida entre em contato com a nossa
        <b>Central de Relacionamento</b>:
      </p>
    </div>

    <div class="welcome-box" v-else>
      <h2 v-if="!isMobile" class="bold welcome">Parabéns!</h2>
      <h2 v-else class="bold welcome" style="font-size: 30px">Parabéns!</h2>
      <div v-if="type == 'adhesion'">
        <p class="bold no-margin">Obrigado por nos escolher!</p>
        <p class="margin-b30">
          Utilize os dados informados na sua adesão para acessar sua conta
          (CPF/CNPJ e senha).
        </p>
      </div>
      <p class="bold no-margin">Fique atento!</p>
      <p class="margin-b30">
        Para segurança de nossos clientes, não solicitamos informações de acesso
        através de e-mail, WhatsApp, SMS ou qualquer outro meio.
      </p>
      <div class="text-center">
        <router-link
          v-if="!isMobile"
          tag="button"
          :to="{ name: 'plans' }"
          class="btn btn-primary margin-20"
          type="button"
          name="button"
        >
          Acessar minha conta
          <i class="icon-circle-right align-icon-right-white"></i>
        </router-link>
        <router-link
          v-else
          tag="button"
          :to="{ name: 'plans' }"
          style="font-size: 12px"
          class="btn btn-primary margin-20"
          type="button"
          name="button"
        >
          Acessar minha conta
          <i class="icon-circle-right align-icon-right-white"></i>
        </router-link>
      </div>
      <p class="margin-t30">
        Em caso de dúvida entre em contato com a nossa
        <b>Central de Relacionamento</b>:
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../../styles/global/_colors.scss";
@import "../../../styles/global/mixin/_mixins.scss";

.welcome-box {
  h2,
  p {
    text-align: center;
  }
  h2 {
    &.welcome {
      font-size: 4em;
      color: $green;
      letter-spacing: 2px;
      margin-bottom: 20px;
    }
  }
  p {
    &.bold {
      font-size: 1.1em;
    }
  }
}

.padding-l25 {
  padding-left: 25px;
}

.modal-success-adhesion {
  .modal-dialog {
    margin: 10% auto 30px;
  }

  .modal-content {
    @include border-radius(0);
  }

  .modal-footer {
    text-align: center;
  }

  .modal-title,
  h4 {
    font-size: 20px;
    letter-spacing: 0;
  }

  .modal-header {
    .close {
      font-weight: normal;
      font-size: 25px;
      color: #707070;
      position: absolute;
      top: 22px;
      right: 15px;
      opacity: 1;
      outline: 0;

      &:focus,
      &:hover,
      &:acitve,
      &.active {
        outline: 0;
      }
    }
  }

  .btn-primary {
    @include border-radius(5px);
    padding: 10px 50px;
  }
}

.success {
  @include border-radius(5px);
  border: 2px solid $gray;
  padding: 20px;
  background-color: #fafafa;

  .success-box {
    h1 {
      margin-top: 0;
    }

    h3 {
      font-size: 20px;
      margin-bottom: 20px;
    }

    .alert-info {
      font-size: 16px;
      line-height: 1.3;
      padding: 10px;
    }

    .alert-margin {
      margin-bottom: 20px;
    }

    .btn {
      width: 180px;
      padding: 10px 25px;

      &.btn-default {
        border: 0;
        margin-left: 20px;
      }

      .align-icon-right-white {
        right: -10px;
      }

      .align-icon-left {
        left: -8px;
        color: white;
      }
    }

    .sub-title {
      color: #4e4e4e;
      font-size: 16px;
      margin: 0;
      line-height: 1;
      position: relative;

      .badge {
        width: 20px;
        height: 20px;
        background-color: white;
        border: 1px solid #707070;
        padding: 4px;
        color: #7e7e7e;
        position: absolute;
        left: -25px;
        top: -2px;
      }
    }

    .sub-info {
      color: #7e7e7e;
      margin: 5px 0 20px;
      line-height: 1.3;

      span {
        font-weight: 500;
      }
    }

    .form-group {
      label {
        color: #444444;
        font-size: 15px;
      }

      .form-control {
        font-size: 18px;
        color: #353535;
        width: 320px;
        height: 45px;
      }
    }
  }

  .error-box {
    h1 {
      font-size: 73px;
      color: #c3c3c3;
      margin-bottom: 25px;
    }

    p {
      font-size: 16px;
      color: #353535;
    }
  }
}

@media screen and (max-width: 991px) {
  .success {
    .success-box {
      h1 {
        font-size: 28px;
      }

      h3 {
        font-size: 18px;
      }

      .sub-title {
        font-size: 14px;
        line-height: 1.2;
      }

      .form-group {
        .form-control {
          max-width: 320px;
          width: 90%;
        }
      }
    }

    .error-box {
      h1 {
        margin-top: 0;
      }

      p {
        font-size: 14px;
        line-height: 1.4;
      }

      .btn-purple {
        width: 220px;
        max-width: 270px;
        padding: 10px;
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 500px) {
  .success {
    .success-box {
      form {
        > div:last-child {
          margin-left: -15px;
        }
      }

      .alert-info {
        font-size: 14px;
      }

      .btn {
        font-size: 12px;
        width: 115px;
        padding: 10px;

        &.btn-default {
          margin-left: 6px;
        }

        i {
          display: none;
        }
      }
    }

    .error-box {
      p {
        font-size: 13px;

        b {
          display: block;
        }

        &.margin-b30 {
          margin-bottom: 10px;
        }
      }
    }
  }
}

.btn-qr-copied {
  background-color: green !important;
  color: white !important;
}
</style>
<script>
import Sales from "../../../services/sales";
import messageDialog from "../../../components/message-dialog.vue";
import QrcodeVue from "qrcode.vue";

export default {
  props: [
    "code",
    "boletoUrl",
    "type",
    "novoCartao",
    "newPix",
    "contractPaymentMethodId",
    "salesOrder",
    "pixCopiaCola",
    "usuario",
    "validado",
  ],
  data() {
    return {
      valorDebitado: undefined,
      isMobile: true,
      isQRCopied: false,
      msgErro: "",
    };
  },
  created() {
    let vm = this;
    this.isMobile = $(window).width() < 1140;
    $(window).resize(function () {
      vm.isMobile = $(window).width() < 1140;
    });
  },
  mounted() {
    if (
      this.type !== "replaceTag" &&
      this.boletoUrl &&
      this.boletoUrl != "0"
    ) {
      window.open(this.boletoUrl);
    }

    if (this.pixCopiaCola) {
      var btnCopyQRCode = document.getElementById("qrcode");
      btnCopyQRCode.addEventListener(
        "click",
        this.copyQRCodePix(this.pixCopiaCola)
      );
      this.isQRCopied = false;
    }
  },

  methods: {
    copyQRCode() {
      this.isQRCopied = false;
      navigator.clipboard
        .writeText(this.pixCopiaCola)
        .then(() => {
          this.isQRCopied = true;
          setTimeout(() => {
            this.isQRCopied = false;
          }, 3000);
        })
        .catch(() => {
          console.log("Não foi possível copiar a string QR Code.");
        });
    },

    copyQRCodePix(pixCopiaCola) {
      this.isQRCopied = false;
      var tempInput = document.createElement("input");
      tempInput.value = pixCopiaCola;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.isQRCopied = true;
      setTimeout(() => {
        this.isQRCopied = false;
      }, 3000);
    },

    showModalSucesso() {
      let vm = this;

      window.setTimeout(function () {
        $("#modalSuccessAdhesion").modal();
        $("#modalSuccessAdhesion").on("hidden.bs.modal", function (e) {
          vm.$router.push({ name: "plans" });
        });
      }, 500);
    },

    confirmCard() {
      var valor = this.valorDebitado.replace(/[^0-9]*/g, "");
      if (valor == 100) {
        return messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            message: "Valor cobrado deve ser entre 1,01 e 1,99",
          })
          .then((r) => {
            this.valorDebitado = null;
            $("#valor-debitado").modal();
          });
      }
      if (this.valorDebitado) {
        messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            type: "YES-NO",
            message:
              "Tem certeza que o valor debitado foi " +
              this.valorDebitado +
              "?",
          })
          .then((e) => {
            if (e == "YES") {
              let req = {
                chargeValue: valor,
                contractPaymentMethodId:
                  this.salesOrder.contractPaymentMethod.contractPaymentMethodId,
              };
              Sales.checkChargeValue(req)
                .then((resp) => {
                  let validaValor = resp.code;
                  if (validaValor == 0) {
                    this.showModalSucesso();
                  }
                })
                .catch((erro) => {
                  let error = erro.data.status.code;
                  var salesOrder = erro.data.salesOrder;
                  if (error == 1) {
                    if (this.primeiroCartao) {
                      this.erroDebito = 2;
                      $("#info-block").modal("hide");
                    } else {
                      this.erroDebito = 1;

                      if (salesOrder) {
                        this.msgErro =
                          "Valor informado incorreto, pedido " +
                          salesOrder.salesOrderId +
                          " será cancelado.";
                      } else
                        this.msgErro =
                          "Valor informado incorreto,cartão cadastrado cancelado.";
                    }
                  } else if (error == 2) {
                    if (this.primeiroCartao) {
                      this.erroDebito = 1;
                      this.msgErro =
                        "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
                      $("#info-block").modal("hide");
                    } else {
                      this.erroDebito = 1;
                      this.msgErro =
                        "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
                    }
                  } else if (error == 3) {
                    this.erroDebito = 1;
                    this.msgErro =
                      "O prazo de validação do cartão expirou. Favor realizar um novo pedido.";
                  } else {
                    this.erroDebito = 1;
                    if (erro.data.status.message) {
                      this.msgErro =
                        "Ocorreu um erro na validação do valor debitado.";
                    } else
                      this.msgErro =
                        "Erro ao validar, favor entrar em contato com a CR!";
                  }
                });
            }
          });
      } else {
        messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            message: "Por favor digite um valor numerico valido",
          })
          .then((r) => {
            this.valorDebitado = null;
          });
      }
    },
  },
  components: {
    QrcodeVue,
  },
};
</script>



// WEBPACK FOOTER //
// success.vue?18ef48c0